import { changeTeamStatus } from "api/Settings";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useChangeTeamStatus = (isBroker: boolean) => {
    const queryClient = useQueryClient();
    return useMutation(changeTeamStatus, {
        onSuccess: () => {
            queryClient.invalidateQueries('teams');
            queryClient.invalidateQueries(['widgetData',isBroker ?'Data Sharing Brokers' : 'Data Sharing Teams']);
            toast.success("Changed Successfully");
        },
        onError: () => {
            toast.error(`Something went wrong`);
        },
    });
};
